// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import 'es6-promise/auto'
import Vue from 'vue'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/ja'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'

import store from './store'
import api from './api'
import websocket from './websocket'
import OffsetPaginator from '@/parts/OffsetPaginator'

Vue.config.productionTip = false
Vue.use(ElementUI, { locale })
Vue.use(api)
Vue.use(websocket)

Vue.prototype.$err400 = function handle400 (err, errorDict = null) {
  let errDict = errorDict || this.errors
  if (!errDict) throw new Error('Error dict is not found.')
  Object.keys(errDict).forEach(k => {
    errDict[k] = []
  })
  if (err.status === 400) {
    let body = err.response.body
    Object.keys(body).forEach(k => {
      errDict[k] = body[k]
    })
    // errDict.nonFieldErrors = [err.response.statusText]
    return true
  }
  return false
}

router.beforeEach(async (to, from, next) => {
  if (to.meta.title) {
    document.title = `KALEIDO - ${to.meta.title}`
  } else {
    document.title = 'KALEIDO'
  }
  if (to.matched.some(record => record.meta.publicPage)) {
    next()
    return
  } else {
    if (!store.getters['account/isLoggedIn']) {
      // 認証済み出ない場合はlocalStorageからtoken復元を試す
      let result = false
      await store.dispatch('account/tryLoggedIn').then(res => {
        result = true
      }, () => {
      })
      if (!result) {
        next({name: 'Login'})
        return
      }
    }
  }
  if (to.matched.some(record => record.meta.agencyOnly) && !store.getters['account/isAgencyUser']) {
    next({name: 'Home'})
    return
  }

  if (!to.matched.some(record => record.meta.agencyOnly) && (!store.getters['account/hasShoporGroup'])) {
    Promise.all([store.dispatch('account/trySetAsShop').catch(() => {}), store.dispatch('account/trySetAsGroup').catch(() => {})]).then(() => {
      if (store.getters['account/hasShopOrGroup']) {
        // グループ/店舗の復元成功
        return Promise.resolve()
      }
      return Promise.reject(new Error('restore failed'))
    }).then(() => {
      next()
    }, () => {
      // reject: 店舗の復元失敗
      next({name: 'ShopSelect'})
    })
    return
  }
  next()
})

Vue.filter('addFigure', function (val) {
  if (!val) {
    return val
  }
  val = val.toString()
  while (val !== (val = val.replace(/^(-?\d+)(\d{3})/, '$1,$2')));
  return val
})

Vue.component(OffsetPaginator.name, OffsetPaginator)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App },
})



// WEBPACK FOOTER //
// ./src/main.js